import React, { useState } from "react";
import stylesTab from "./studentWorld.module.scss";
import styles from "./studentWorld.module.scss";
import studenWorkBanner from "../../assets/images/studenWorkBanner.png";
import StudentWorkCard from "../CustomComponent/StudentWorkCard.tsx";

import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import WebsiteDesignImgOne from "../../assets/images/WebsiteDesignImgOne.jpg";
import WebsiteDesignImgOneCornerTop from "../../assets/images/WebsiteDesignImgOneCornerTop.png";
import WebsiteDesignImgOneCornerBottom from "../../assets/images/WebsiteDesignImgOneCornerBottom.png";
import WebsiteDesignImgTwo from "../../assets/images/WebsiteDesignImgTwo.jpg";
import WebsiteDesignImgTwoCornerTop from "../../assets/images/WebsiteDesignImgTwoCornerTop.png";
import WebsiteDesignImgTwoCornerBottom from "../../assets/images/WebsiteDesignImgTwoCornerBottom.png";
import WebsiteDesignImgThree from "../../assets/images/WebsiteDesignImgThree.jpg";
import WebsiteDesignImgThreeCornerTop from "../../assets/images/WebsiteDesignImgThreeCornerTop.png";
import WebsiteDesignImgThreeCornerBottom from "../../assets/images/WebsiteDesignImgThreeCornerBottom.png";
import WebsiteDesignImgFour from "../../assets/images/WebsiteDesignImgFour.png";
import WebsiteDesignImgFourCornerTop from "../../assets/images/WebsiteDesignImgFourCornerTop.png";
import WebsiteDesignImgFourCornerBottom from "../../assets/images/WebsiteDesignImgFourCornerBottom.png";
import GraphicDesignImgOne from "../../assets/images/GraphicDesignImgOne.png";
import GraphicDesignImgOneCornerTop from "../../assets/images/GraphicDesignImgOneCornerTop.png";
import GraphicDesignImgOneCornerBottom from "../../assets/images/GraphicDesignImgOneCornerBottom.png";
import GraphicDesignImgTwo from "../../assets/images/GraphicDesignImgTwo.png";
import GraphicDesignImgTwoCornerTop from "../../assets/images/GraphicDesignImgTwoCornerTop.png";
import GraphicDesignImgTwoCornerBottom from "../../assets/images/GraphicDesignImgTwoCornerBottom.png";
import GraphicDesignImgThree from "../../assets/images/GraphicDesignImgThree.png";
import GraphicDesignImgThreeCornerTop from "../../assets/images/GraphicDesignImgThreeCornerTop.png";
import GraphicDesignImgThreeCornerBottom from "../../assets/images/GraphicDesignImgThreeCornerBottom.png";
import GraphicDesignImgFour from "../../assets/images/GraphicDesignImgFour.png";
import GraphicDesignImgFourCornerTop from "../../assets/images/GraphicDesignImgFourCornerTop.png";
import GraphicDesignImgFourCornerBottom from "../../assets/images/GraphicDesignImgFourCornerBottom.png";
import GraphicDesignImgFive from "../../assets/images/GraphicDesignImgFive.png";
import GraphicDesignImgFiveCornerTop from "../../assets/images/GraphicDesignImgFiveCornerTop.png";
import GraphicDesignImgFiveCornerBottom from "../../assets/images/GraphicDesignImgFiveCornerBottom.png";
import GraphicDesignImgSix from "../../assets/images/GraphicDesignImgSix.png";
import GraphicDesignImgSixCornerTop from "../../assets/images/GraphicDesignImgSixCornerTop.png";
import GraphicDesignImgSixCornerBottom from "../../assets/images/GraphicDesignImgSixCornerBottom.png";
import GraphicDesignImgSeven from "../../assets/images/GraphicDesignImgSeven.png";
import GraphicDesignImgSevenCornerTop from "../../assets/images/GraphicDesignImgSevenCornerTop.png";
import GraphicDesignImgSevenCornerBottom from "../../assets/images/GraphicDesignImgSevenCornerBottom.png";
import GraphicDesignImgEight from "../../assets/images/GraphicDesignImgEight.png";
import GraphicDesignImgEightCornerTop from "../../assets/images/GraphicDesignImgEightCornerTop.png";
import GraphicDesignImgEightCornerBottom from "../../assets/images/GraphicDesignImgEightCornerBottom.png";
import GraphicDesignImgNine from "../../assets/images/GraphicDesignImgNine.png";
import GraphicDesignImgNineCornerTop from "../../assets/images/GraphicDesignImgNineCornerTop.png";
import GraphicDesignImgNineCornerBottom from "../../assets/images/GraphicDesignImgNineCornerBottom.png";
import GraphicDesignImgTen from "../../assets/images/GraphicDesignImgTen.png";
import GraphicDesignImgTenCornerTop from "../../assets/images/GraphicDesignImgTenCornerTop.png";
import GraphicDesignImgTenCornerBottom from "../../assets/images/GraphicDesignImgTenCornerBottom.png";

import MotionComicImgOne from "../../assets/images/MotionComicImgOne.jpg";
import MotionComicImgOneCornerTop from "../../assets/images/MotionComicImgOneCornerTop.png";
import MotionComicImgOneCornerBottom from "../../assets/images/MotionComicImgOneCornerBottom.png";
import MotionComicImgTwo from "../../assets/images/MotionComicImgTwo.png";
import MotionComicImgTwoCornerTop from "../../assets/images/MotionComicImgTwoCornerTop.png";
import MotionComicImgTwoCornerBottom from "../../assets/images/MotionComicImgTwoCornerBottom.png";
import GamingImgOne from "../../assets/images/GamingImgOne.jpg";
import GamingImgOneCornerTop from "../../assets/images/GamingImgOneCornerTop.png";
import GamingImgOneCornerBottom from "../../assets/images/GamingImgOneCornerBottom.png";
import GamingImgTwo from "../../assets/images/GamingImgTwo.jpg";
import GamingImgTwoCornerTop from "../../assets/images/GamingImgTwoCornerTop.png";
import GamingImgTwoCornerBottom from "../../assets/images/GamingImgTwoCornerBottom.png";
import GamingImgThree from "../../assets/images/GamingImgThree.jpg";
import GamingImgThreeCornerTop from "../../assets/images/GamingImgThreeCornerTop.png";
import GamingImgThreeCornerBottom from "../../assets/images/GamingImgThreeCornerBottom.png";
import GamingImgFour from "../../assets/images/GamingImgFour.jpg";
import GamingImgFourCornerTop from "../../assets/images/GamingImgFourCornerTop.png";
import GamingImgFourCornerBottom from "../../assets/images/GamingImgFourCornerBottom.png";

import DigitalDesignImgOne from "../../assets/images/DigitalDesignImgOne.jpg";
import DigitalDesignImgOneCornerTop from "../../assets/images/DigitalDesignImgOneCornerTop.png";
import DigitalDesignImgOneCornerBottom from "../../assets/images/DigitalDesignImgOneCornerBottom.png";
import DigitalDesignImgTwo from "../../assets/images/DigitalDesignImgTwo.jpg";
import DigitalDesignImgTwoCornerTop from "../../assets/images/DigitalDesignImgTwoCornerTop.png";
import DigitalDesignImgTwoCornerBottom from "../../assets/images/DigitalDesignImgTwoCornerBottom.png";
import DigitalDesignImgThree from "../../assets/images/DigitalDesignImgThree.png";
import DigitalDesignImgThreeCornerTop from "../../assets/images/DigitalDesignImgThreeCornerTop.png";
import DigitalDesignImgThreeCornerBottom from "../../assets/images/DigitalDesignImgThreeCornerBottom.png";
import DigitalDesignImgFour from "../../assets/images/DigitalDesignImgFour.png";
import DigitalDesignImgFourCornerTop from "../../assets/images/DigitalDesignImgFourCornerTop.png";
import DigitalDesignImgFourCornerBottom from "../../assets/images/DigitalDesignImgFourCornerBottom.png";

//Beauty
import BeautyCenter1 from "../../assets/images/BeautyCenter1.jpg";
import BeautyTopCorner1 from "../../assets/images/BeautyTopCorner1.png";
import BeautyBottomCorner1 from "../../assets/images/BeautyBottomCorner1.png";
import BeautyCenter2 from "../../assets/images/BeautyCenter2.jpg";
import BeautyTopCorner2 from "../../assets/images/BeautyTopCorner2.png";
import BeautyBottomCorner2 from "../../assets/images/BeautyBottomCorner2.png";
import BeautyCenter3 from "../../assets/images/BeautyCenter3.jpg";
import BeautyTopCorner3 from "../../assets/images/BeautyTopCorner3.png";
import BeautyBottomCorner3 from "../../assets/images/BeautyBottomCorner3.png";
import BeautyCenter4 from "../../assets/images/BeautyCenter4.jpg";
import BeautyTopCorner4 from "../../assets/images/BeautyTopCorner4.png";
import BeautyBottomCorner4 from "../../assets/images/BeautyBottomCorner4.png";
import BeautyCenter5 from "../../assets/images/BeautyCenter5.jpg";
import BeautyTopCorner5 from "../../assets/images/BeautyTopCorner5.png";
import BeautyBottomCorner5 from "../../assets/images/BeautyBottomCorner5.png";
import BeautyCenter6 from "../../assets/images/BeautyCenter6.jpg";
import BeautyTopCorner6 from "../../assets/images/BeautyTopCorner6.png";
import BeautyBottomCorner6 from "../../assets/images/BeautyBottomCorner6.png";
import BeautyCenter7 from "../../assets/images/BeautyCenter7.jpg";
import BeautyTopCorner7 from "../../assets/images/BeautyTopCorner7.png";
import BeautyBottomCorner7 from "../../assets/images/BeautyBottomCorner7.png";
import BeautyCenter8 from "../../assets/images/BeautyCenter8.jpg";
import BeautyTopCorner8 from "../../assets/images/BeautyTopCorner8.png";
import BeautyBottomCorner8 from "../../assets/images/BeautyBottomCorner8.png";
import BeautyCenter9 from "../../assets/images/BeautyCenter9.jpg";
import BeautyTopCorner9 from "../../assets/images/BeautyTopCorner9.png";
import BeautyBottomCorner9 from "../../assets/images/BeautyBottomCorner9.png";
import BeautyCenter10 from "../../assets/images/BeautyCenter10.jpg";
import BeautyTopCorner10 from "../../assets/images/BeautyTopCorner10.png";
import BeautyBottomCorner10 from "../../assets/images/BeautyBottomCorner10.png";
import BeautyCenter11 from "../../assets/images/BeautyCenter11.jpg";
import BeautyTopCorner11 from "../../assets/images/BeautyTopCorner11.png";
import BeautyBottomCorner11 from "../../assets/images/BeautyBottomCorner11.png";
import BeautyCenter12 from "../../assets/images/BeautyCenter12.jpg";
import BeautyTopCorner12 from "../../assets/images/BeautyTopCorner12.png";
import BeautyBottomCorner12 from "../../assets/images/BeautyBottomCorner12.png";
import BeautyCenter13 from "../../assets/images/BeautyCenter13.jpg";
import BeautyTopCorner13 from "../../assets/images/BeautyTopCorner13.png";
import BeautyBottomCorner13 from "../../assets/images/BeautyBottomCorner13.png";
import BeautyCenter14 from "../../assets/images/BeautyCenter14.jpg";
import BeautyTopCorner14 from "../../assets/images/BeautyTopCorner14.png";
import BeautyBottomCorner14 from "../../assets/images/BeautyBottomCorner14.png";
import BeautyCenter15 from "../../assets/images/BeautyCenter15.jpg";
import BeautyTopCorner15 from "../../assets/images/BeautyTopCorner15.png";
import BeautyBottomCorner15 from "../../assets/images/BeautyBottomCorner15.png";
import BeautyCenter16 from "../../assets/images/BeautyCenter16.jpg";
import BeautyTopCorner16 from "../../assets/images/BeautyTopCorner16.png";
import BeautyBottomCorner16 from "../../assets/images/BeautyBottomCorner16.png";

//VFX
import VfxCenter1 from "../../assets/images/VfxCenter1.jpg";
import VfxTopCorner1 from "../../assets/images/VfxTopCorner1.png";
import VfxBottomCorner1 from "../../assets/images/VfxBottomCorner1.png";
import VfxCenter2 from "../../assets/images/VfxCenter2.png";
import VfxTopCorner2 from "../../assets/images/VfxTopCorner2.png";
import VfxBottomCorner2 from "../../assets/images/VfxBottomCorner2.png";

//Animation
import AnimationCenter1 from "../../assets/images/AnimationCenter1.jpg";
import AnimationTopCorner1 from "../../assets/images/AnimationTopCorner1.png";
import AnimationBottomCorner1 from "../../assets/images/AnimationBottomCorner1.png";
import AnimationCenter2 from "../../assets/images/AnimationCenterImg2.jpg";
import AnimationTopCorner2 from "../../assets/images/AnimationTopCorner2.png";
import AnimationBottomCorner2 from "../../assets/images/AnimationBottomCorner2.png";
import AnimationCenter3 from "../../assets/images/AnimationCenter3.jpg";
import AnimationTopCorner3 from "../../assets/images/AnimationTopCorner3.png";
import AnimationBottomCorner3 from "../../assets/images/AnimationBottomCorner3.png";
import AnimationCenter4 from "../../assets/images/AnimationCenter4.jpg";
import AnimationTopCorner4 from "../../assets/images/AnimationTopCorner4.png";
import AnimationBottomCorner4 from "../../assets/images/AnimationBottomCorner4.png";
import AnimationCenter5 from "../../assets/images/AnimationCenter5.jpg";
import AnimationTopCorner5 from "../../assets/images/AnimationTopCorner5.png";
import AnimationBottomCorner5 from "../../assets/images/AnimationBottomCorner5.png";
import AnimationCenter6 from "../../assets/images/AnimationCenter6.jpg";
import AnimationTopCorner6 from "../../assets/images/AnimationTopCorner6.png";
import AnimationBottomCorner6 from "../../assets/images/AnimationBottomCorner6.png";
import AnimationCenter7 from "../../assets/images/AnimationCenter7.jpg";
import AnimationTopCorner7 from "../../assets/images/AnimationTopCorner7.png";
import AnimationBottomCorner7 from "../../assets/images/AnimationBottomCorner7.png";
import AnimationCenter8 from "../../assets/images/AnimationCenter8.png";
import AnimationTopCorner8 from "../../assets/images/AnimationTopCorner8.png";
import AnimationBottomCorner8 from "../../assets/images/AnimationBottomCorner8.png";
import AnimationCenter9 from "../../assets/images/AnimationCenter9.png";
import AnimationTopCorner9 from "../../assets/images/AnimationTopCorner9.png";
import AnimationBottomCorner9 from "../../assets/images/AnimationBottomCorner9.png";
import AnimationCenter10 from "../../assets/images/AnimationCenter10.png";
import AnimationTopCorner10 from "../../assets/images/AnimationTopCorner10.png";
import AnimationBottomCorner10 from "../../assets/images/AnimationBottomCorner10.png";
import AnimationCenter11 from "../../assets/images/AnimationCenter11.png";
import AnimationTopCorner11 from "../../assets/images/AnimationTopCorner11.png";
import AnimationBottomCorner11 from "../../assets/images/AnimationBottomCorner11.png";





interface Section {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionAnimation {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionBeauty {
  title?: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionWebsiteDesign {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionVfx {
  title?: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionGraphicDesign {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionMotionComic {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
interface SectionGaming {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}

interface DigitalDesign {
  title: string;
  mainImage?: string;
  corner1: string;
  corner2: string;
  id?: number;
  video?: string;
  thumbnail?: string;
}
const sections: Section[] = [
  {
    title: "Beauty",
    id: 1,
    mainImage: BeautyCenter1,
    corner1: BeautyTopCorner1,
    corner2: BeautyBottomCorner1,
  },
  {
    id: 2,
    title: "VFX",
    corner1: VfxTopCorner1,
    corner2: VfxBottomCorner1,
    video: "https://youtu.be/lKDLs-Io2GU",
    thumbnail: VfxCenter1,
  },
  {
    id: 3,
    title: "Gaming",
    mainImage: GamingImgOne,
    corner1: GamingImgOneCornerTop,
    corner2: GamingImgOneCornerBottom,
  },
  {
  id: 4,
  title: "Animation",
  corner1: AnimationTopCorner1,
  corner2: AnimationBottomCorner1,
  video: "https://www.youtube.com/watch?v=GQt_4CxOxpg",
  thumbnail: AnimationCenter1,
  },
  
  {
    id: 5,
    title: "Graphic design",
    mainImage: GraphicDesignImgOne,
    corner1: GraphicDesignImgOneCornerTop,
    corner2: GraphicDesignImgOneCornerBottom,
  },
  {
    id: 6,
    title: "Digital design",
    mainImage: DigitalDesignImgOne,
    corner1: DigitalDesignImgOneCornerTop,
    corner2: DigitalDesignImgOneCornerBottom,
  },
  {
    id: 7,
    title: "Website design",
    corner1: WebsiteDesignImgOneCornerTop,
    corner2: WebsiteDesignImgOneCornerBottom,
    video: "https://www.youtube.com/watch?v=BumVdSJiEVI",
    thumbnail: WebsiteDesignImgOne,
  },
  {
    id: 8,
    title: "Motion comic",
    corner1: MotionComicImgOneCornerTop,
    corner2: MotionComicImgOneCornerBottom,
    video: "https://youtu.be/JOIFvU_27Lo",
    thumbnail: MotionComicImgOne,
  },
];
const sectionsBeauty: SectionBeauty[] = [
  {
    title: "Beauty",
    id: 1,
    mainImage: BeautyCenter1,
    corner1: BeautyTopCorner1,
    corner2: BeautyBottomCorner1,
  },
  {
    id: 2,
    title: "Beauty",
    mainImage: BeautyCenter2,
    corner1: BeautyTopCorner2,
    corner2: BeautyBottomCorner2,
  },
  {
    id: 3,
    title: "Beauty",
    mainImage: BeautyCenter3,
    corner1: BeautyTopCorner3,
    corner2: BeautyBottomCorner3,
  },
  {
    id: 4,
    title: "Beauty",
    mainImage: BeautyCenter4,
    corner1: BeautyTopCorner4,
    corner2: BeautyBottomCorner4,
  },
  {
    id: 5,
    title: "Beauty",
    mainImage: BeautyCenter5,
    corner1: BeautyTopCorner5,
    corner2: BeautyBottomCorner5,
  },
  {
    id: 6,
    title: "Beauty",
    mainImage: BeautyCenter6,
    corner1: BeautyTopCorner6,
    corner2: BeautyBottomCorner6,
  },
  {
    id: 7,
    title: "Beauty",
    mainImage: BeautyCenter7,
    corner1: BeautyTopCorner7,
    corner2: BeautyBottomCorner7,
  },
  {
    id: 8,
    title: "Beauty",
    mainImage: BeautyCenter8,
    corner1: BeautyTopCorner8,
    corner2: BeautyBottomCorner8,
  },
  {
    id: 9,
    title: "Beauty",
    mainImage: BeautyCenter9,
    corner1: BeautyTopCorner9,
    corner2: BeautyBottomCorner9,
  },
  {
    id: 10,
    title: "Beauty",
    corner1: BeautyTopCorner10,
    corner2: BeautyBottomCorner10,
    video: "https://www.youtube.com/shorts/UwOTDuGpdFM",
    thumbnail: BeautyCenter10,
  },
  {
    id: 11,
    title: "Beauty",
    corner1: BeautyTopCorner11,
    corner2: BeautyBottomCorner11,
    video: "https://www.youtube.com/shorts/1mz3PR3YcY8",
    thumbnail: BeautyCenter11,
  },
  {
    id: 12,
    title: "Beauty",
    corner1: BeautyTopCorner12,
    corner2: BeautyBottomCorner12,
    video: "https://www.youtube.com/shorts/upRunTNdwjA",
    thumbnail: BeautyCenter12,
  },
  {
    title: "Beauty",
    corner1: BeautyTopCorner13,
    corner2: BeautyBottomCorner13,
    id: 13,
    video: "https://www.youtube.com/shorts/EVwRcI5w3b8",
    thumbnail: BeautyCenter13,
  },
  {
    id: 14,
    title: "Beauty",
    corner1: BeautyTopCorner14,
    corner2: BeautyBottomCorner14,
    video: "https://www.youtube.com/shorts/7qfGdB09Nr0",
    thumbnail: BeautyCenter14,
  },
  {
    id: 15,
    title: "Beauty",
    corner1: BeautyTopCorner15,
    corner2: BeautyBottomCorner15,
    video: "https://www.youtube.com/shorts/D-GcjnQiWqo",
    thumbnail: BeautyCenter15,
  },
  {
    id: 16,
    title: "Beauty",
    corner1: BeautyTopCorner16,
    corner2: BeautyBottomCorner16,
    video: "https://www.youtube.com/shorts/_vd2nK_I42g",
    thumbnail: BeautyCenter16,
  },
];

const sectionsVfx: SectionVfx[] = [
  {
    title: "VFX",
    corner1: VfxTopCorner1,
    corner2: VfxBottomCorner1,
    id: 1,
    video: "https://youtu.be/lKDLs-Io2GU",
    thumbnail: VfxCenter1,
  },
  {
    title: "VFX",
    corner1: VfxTopCorner2,
    corner2: VfxBottomCorner2,
    id: 2,
    video: "https://www.youtube.com/watch?v=9fBTHvCNMFQ",
    thumbnail: VfxCenter2,
  },
  // {
  //   title: "Website Design",
  //   mainImage: digitalDesignCenter,
  //   corner1: digitalDesignCorner1,
  //   corner2: digitalDesignCorner2,
  // },
];

const sectionsAnimation: SectionAnimation[] = [
  {
    id: 1,
    title: "Animation",
    corner1: AnimationTopCorner1,
    corner2: AnimationBottomCorner1,
    video: "https://www.youtube.com/watch?v=GQt_4CxOxpg",
    thumbnail: AnimationCenter1,
  },
  {
    id: 2,
    title: "Animation",
    corner1: AnimationTopCorner2,
    corner2: AnimationBottomCorner2,
    video: "https://www.youtube.com/watch?v=M1Hy6dT_VSc",
    thumbnail: AnimationCenter2,
  },
  {
    id: 3,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=rie0szOJY9E",
    thumbnail: AnimationCenter3,
    corner1: AnimationTopCorner3,
    corner2: AnimationBottomCorner3,
  },
  {
    id: 4,
    title: "Animation",
    video: "https://youtu.be/epVtpXWKluE",
    thumbnail: AnimationCenter4,
    corner1: AnimationTopCorner4,
    corner2: AnimationBottomCorner4,
  },
  {
    id: 5,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=-vdQDustn08",
    thumbnail: AnimationCenter5,
    corner1: AnimationTopCorner5,
    corner2: AnimationBottomCorner5,
  },
  {
    id: 6,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=UzH1NV91rHo",
    thumbnail: AnimationCenter6,
    corner1: AnimationTopCorner6,
    corner2: AnimationBottomCorner6,
  },
  {
    id: 7,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=pPApe6fOzOI",
    thumbnail: AnimationCenter7,
    corner1: AnimationBottomCorner7,
    corner2: AnimationTopCorner7,
  },
  {
    id: 8,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=7xiohOehaTs",
    thumbnail: AnimationCenter8,
    corner1: AnimationBottomCorner8,
    corner2: AnimationTopCorner8,
  },
  {
    id: 9,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=P2eGjcq-_dE",
    thumbnail: AnimationCenter9,
    corner1: AnimationBottomCorner9,
    corner2: AnimationTopCorner9,
  },
  {
    id: 10,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=GeVA6faC850",
    thumbnail: AnimationCenter10,
    corner1: AnimationBottomCorner10,
    corner2: AnimationTopCorner10,
  },
  {
    id: 11,
    title: "Animation",
    video: "https://www.youtube.com/watch?v=7AHOGTYYcSc",
    thumbnail: AnimationCenter11,
    corner1: AnimationBottomCorner11,
    corner2: AnimationTopCorner11,
  },
];

const sectionsWebsiteDesign: SectionWebsiteDesign[] = [
  {
    title: "Website design",
    corner1: WebsiteDesignImgOneCornerTop,
    corner2: WebsiteDesignImgOneCornerBottom,
    id: 1,
    video: "https://www.youtube.com/watch?v=BumVdSJiEVI",
    thumbnail: WebsiteDesignImgOne,
  },
  {
    title: "Website design",
    corner1: WebsiteDesignImgTwoCornerTop,
    corner2: WebsiteDesignImgTwoCornerBottom,
    id: 2,
    video: "https://www.youtube.com/watch?v=bs4N8QuVAnc",
    thumbnail: WebsiteDesignImgTwo,
  },
  {
    title: "Website design",
    corner1: WebsiteDesignImgThreeCornerTop,
    corner2: WebsiteDesignImgThreeCornerBottom,
    id: 3,
    video: "https://youtu.be/xjs6vFvQ_S8",
    thumbnail: WebsiteDesignImgThree,
  },
  {
    title: "Website design",
    corner1: WebsiteDesignImgFourCornerTop,
    corner2: WebsiteDesignImgFourCornerBottom,
    id: 4,
    video: "https://www.youtube.com/watch?v=cFux8IwIjY0",
    thumbnail: WebsiteDesignImgFour,
  },
];

const sectionsGraphicDesign: SectionGraphicDesign[] = [
  {
    id: 1,
    title: "Graphic design",
    mainImage: GraphicDesignImgOne,
    corner1: GraphicDesignImgOneCornerTop,
    corner2: GraphicDesignImgOneCornerBottom,
  },
  {
    id: 2,
    title: "Graphic design",
    mainImage: GraphicDesignImgTwo,
    corner1: GraphicDesignImgTwoCornerTop,
    corner2: GraphicDesignImgTwoCornerBottom,
  },
  {
    id: 3,
    title: "Graphic design",
    mainImage: GraphicDesignImgThree,
    corner1: GraphicDesignImgThreeCornerTop,
    corner2: GraphicDesignImgThreeCornerBottom,
  },
  {
    id: 4,
    title: "Graphic design",
    mainImage: GraphicDesignImgFour,
    corner1: GraphicDesignImgFourCornerTop,
    corner2: GraphicDesignImgFourCornerBottom,
  },
  {
    id: 5,
    title: "Graphic design",
    mainImage: GraphicDesignImgFive,
    corner1: GraphicDesignImgFiveCornerTop,
    corner2: GraphicDesignImgFiveCornerBottom,
  },
  {
    id: 6,
    title: "Graphic design",
    mainImage: GraphicDesignImgSix,
    corner1: GraphicDesignImgSixCornerTop,
    corner2: GraphicDesignImgSixCornerBottom,
  },
  {
    id: 7,
    title: "Graphic design",
    mainImage: GraphicDesignImgSeven,
    corner1: GraphicDesignImgSevenCornerTop,
    corner2: GraphicDesignImgSevenCornerBottom,
  },
  {
    id: 8,
    title: "Graphic design",
    mainImage: GraphicDesignImgEight,
    corner1: GraphicDesignImgEightCornerTop,
    corner2: GraphicDesignImgEightCornerBottom,
  },
  {
    id: 9,
    title: "Graphic design",
    mainImage: GraphicDesignImgNine,
    corner1: GraphicDesignImgNineCornerTop,
    corner2: GraphicDesignImgNineCornerBottom,
  },
  {
    id: 10,
    title: "Graphic design",
    mainImage: GraphicDesignImgTen,
    corner1: GraphicDesignImgTenCornerTop,
    corner2: GraphicDesignImgTenCornerBottom,
  },
];

const sectionsMotionComic: SectionMotionComic[] = [
  {
    title: "Motion comic",
    corner1: MotionComicImgOneCornerTop,
    corner2: MotionComicImgOneCornerBottom,
    id: 1,
    video: "https://youtu.be/JOIFvU_27Lo",
    thumbnail: MotionComicImgOne,
  },
  {
    title: "Motion comic",
    corner1: MotionComicImgTwoCornerTop,
    corner2: MotionComicImgTwoCornerBottom,
    id: 2,
    video: "https://youtu.be/IvLhPcIEApw",
    thumbnail: MotionComicImgTwo,
  },
];

const sectionsGaming: SectionGaming[] = [
  {
    title: "Gaming",
    mainImage: GamingImgOne,
    corner1: GamingImgOneCornerTop,
    corner2: GamingImgOneCornerBottom,
  },
  {
    title: "Gaming",
    mainImage: GamingImgTwo,
    corner1: GamingImgTwoCornerTop,
    corner2: GamingImgTwoCornerBottom,
  },
  {
    title: "Gaming",
    mainImage: GamingImgThree,
    corner1: GamingImgThreeCornerTop,
    corner2: GamingImgThreeCornerBottom,
  },
  {
    title: "Gaming",
    mainImage: GamingImgFour,
    corner1: GamingImgFourCornerTop,
    corner2: GamingImgFourCornerBottom,
  },
];

const sectionsDigitalDesign: DigitalDesign[] = [
  {
    id: 1,
    title: "Digital design",
    mainImage: DigitalDesignImgOne,
    corner1: DigitalDesignImgOneCornerTop,
    corner2: DigitalDesignImgOneCornerBottom,
  },
  {
    id: 2,
    title: "Digital design",
    mainImage: DigitalDesignImgTwo,
    corner1: DigitalDesignImgTwoCornerTop,
    corner2: DigitalDesignImgTwoCornerBottom,
  },
  {
    id: 3,
    title: "Digital design",
    mainImage: DigitalDesignImgThree,
    corner1: DigitalDesignImgThreeCornerTop,
    corner2: DigitalDesignImgThreeCornerBottom,
  },
  {
    id: 4,
    title: "Digital design",
    mainImage: DigitalDesignImgFour,
    corner1: DigitalDesignImgFourCornerTop,
    corner2: DigitalDesignImgFourCornerBottom,
  },
];

const StudentWork: React.FC = () => {
  const [activeTab, setActiveTab] = useState("ALL");
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Student World", link: "/students-world" },
    { title: "Student's Works", link: "" },
  ];

  const [playingVideoId, setPlayingVideoId] = useState<number | null>(null);

  const handlePlay = (id: number) => {
    setPlayingVideoId((prevId) => (prevId === id ? null : id));
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setPlayingVideoId(null);
  };

  const combinedSections = [
    ...(sectionsBeauty || []),
    ...(sectionsAnimation || []),
    ...(sectionsVfx || []),
    ...(sectionsGaming || []),
    ...(sectionsGraphicDesign || []),
    ...(sectionsDigitalDesign || []),
    ...(sectionsWebsiteDesign || []),
    ...(sectionsMotionComic || []),
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "ALL":
        return (
          <div className="row g-3">
            {sections.map((section) => (
              <StudentWorkCard
                key={section?.id}
                section={section}
                sections={combinedSections}
                showTitle={true}
                playingVideoId={playingVideoId}
                onPlay={handlePlay}
              />
            ))}
          </div>
        );
      case "ANIMATION":
        return (
          <div className="row g-3">
            {sectionsAnimation.map((section, index) => (
              <StudentWorkCard
                section={section}
                topPadding="25px"
                playingVideoId={playingVideoId}
                onPlay={handlePlay}
                showTitle={false}

              />
            ))}
          </div>
        );
      case "VFX":
        return (
          <div className="row g-3">
            {sectionsVfx.map((section, index) => (
              <StudentWorkCard
                key={index}
                section={section}
                showTitle={false}
                topPadding="25px"
                playingVideoId={playingVideoId}
                onPlay={handlePlay}
              />
            ))}
          </div>
        );
      case "BEAUTY":
        return (
          <div className="row g-3">
            {sectionsBeauty.map((section, index) => (
              <StudentWorkCard
                key={index}
                section={section}
                // sections={sections}
                topPadding="25px"
                playingVideoId={playingVideoId}
                onPlay={handlePlay}
                showTitle={false}
              />
            ))}
          </div>
        );
      case "WEBSITE DESIGN":
        return (
          <div>
            <div className="row g-3">
              {sectionsWebsiteDesign.map((section, index) => (
                <StudentWorkCard
                  key={index}
                  section={section}
                  topPadding="25px"
                  playingVideoId={playingVideoId}
                  onPlay={handlePlay}
                  showTitle={false}
                />
              ))}
            </div>
          </div>
        );
      case "GRAPHIC DESIGN":
        return (
          <div>
            <div className="row g-3">
              {sectionsGraphicDesign.map((section, index) => (
                <StudentWorkCard
                  key={index}
                  section={section}
                  topPadding="25px"
                  playingVideoId={playingVideoId}
                onPlay={handlePlay}
                showTitle={false}
                />
              ))}
            </div>
          </div>
        );
      case "MOTION COMIC":
        return (
          <div>
            <div className="row g-3">
              {sectionsMotionComic.map((section, index) => (
                <StudentWorkCard
                  key={index}
                  section={section}
                  topPadding="25px"
                  playingVideoId={playingVideoId}
                onPlay={handlePlay}
                showTitle={false}
                />
              ))}
            </div>
          </div>
        );
      case "GAMING":
        return (
          <div>
            <div className="row g-3">
              {sectionsGaming.map((section, index) => (
                <StudentWorkCard
                  key={index}
                  section={section}
                  topPadding="25px"
                  playingVideoId={playingVideoId}
                onPlay={handlePlay}
                showTitle={false}
                />
              ))}
            </div>
          </div>
        );
      case "DIGITAL DESIGN":
        return (
          <div>
            <div className="row g-3">
              {sectionsDigitalDesign.map((section, index) => (
                <StudentWorkCard
                  key={index}
                  section={section}
                  topPadding="25px"
                  playingVideoId={playingVideoId}
                onPlay={handlePlay}
                showTitle={false}
                />
              ))}
            </div>
          </div>
        );
      default:
        return <div>No Content</div>;
    }
  };
  const content = [
    `At Aptech, students go beyond classroom learning, applying their skills to real-time projects. This enables them to showcase their creativity, technical expertise, and commitment to transforming themselves into skilled professionals.   `,
    `While many students have gone on to work with animation studios, VFX companies, and beauty and wellness brands, others have launched their own ventures, creating independent films, ad shoots, and beauty and wellness and fashion shows for various beauty and wellness and fashion labels. This page is dedicated to showcasing the exceptional projects and artworks crafted by the talented students across diverse fields such as <strong>Animation</strong>, <strong>VFX<strong>, and <strong>Beauty and Wellness.</strong> `,
  ];
  return (
    <div id="StudentWork" className={styles.studentWork}>
      <BreadCrumb menu={breadcrumb} />

      {/* <div className="container"> */}
      <div className="section">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12">
              <ImageTextSection
                imageSrc={studenWorkBanner}
                imageAlt="Student work Image"
                content={content}
                colImageValue={5}
                colTextValue={7}
                heading="Students’ Works"
                reverse={true}
                imageAlign="end"
              />
              <p className="subHeading mt-5">
                <strong>
                  Snippets of students’ works spanning across the Animation,
                  VFX, and Beauty and Wellness industries.
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div className={` ${styles.tabsContainer}`}>
          <ul
            className={`nav nav-pills mb-3 ${styles.navPills} d-flex overflow-auto`}
            id="pills-tab"
            role="tablist"
            style={{ whiteSpace: "nowrap" }}
          >
            {[
              "ALL",
              "ANIMATION",
              "VFX",
              "BEAUTY",
              "GAMING",
              "GRAPHIC DESIGN",
              "DIGITAL DESIGN",
              "WEBSITE DESIGN",
              "MOTION COMIC",
            ].map((tab) => (
              <li
                key={tab}
                className="nav-item me-3 flex-shrink-0"
                role="presentation"
              >
                <button
                  className={`secondary-btn mb-md-3 ${stylesTab.navLink} ${
                    activeTab === tab ? stylesTab.navLinkActive : ""
                  }`}
                  onClick={() => handleTabClick(tab)}
                  type="button"
                  role="tab"
                  aria-controls={`pills-${tab.toLowerCase()}`}
                  aria-selected={activeTab === tab}
                >
                  {tab}
                </button>
              </li>
            ))}
          </ul>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tab-content" id="pills-tabContent">
                  {renderTabContent()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default StudentWork;
